import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfig } from '../helpers/app.config';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(
    private httpClient: HttpClient,
    private utilsService: UtilsService
  ) { }

  public generateReportToken(form): Observable<any> {
    delete form.idealProfile;
    const cleanReportParams = this.utilsService.cleanParams(form);

    return this.httpClient.get<any>(AppConfig.settings.API + '/report/token', { params: cleanReportParams });
  }

  public getMDWebReport(token, languageId) {
    window.open(AppConfig.settings.HOME + '/#/report/md/' + token + '?languageId=' + languageId);
  }

  public getCTWebReport(token, languageId) {
    window.open(AppConfig.settings.HOME + '/#/report/ct/' + token + '?languageId=' + languageId);
  }

  public getEvalualiaWebReport(token, languageId) {
    window.open(AppConfig.settings.HOME + '/#/report/evalualia/' + token + '?languageId=' + languageId);
  }

  public getMDPdfReport(form, fileName): Observable<any> {
    delete form.idealProfile;
    delete form.adjustment;
    const cleanReportParams = this.utilsService.cleanParams(form);

    return this.httpClient.get<any>(AppConfig.settings.API + '/external/md/report', {
      params: { ...cleanReportParams, fileName } as any,
      responseType: 'text' as any
    });
  }

  public getAdnPdfReport(form, fileName): Observable<any> {
    const cleanReportParams = this.utilsService.cleanParams(form);

    return this.httpClient.get<any>(AppConfig.settings.API + '/reports/pdf', {
      params: { ...cleanReportParams, fileName } as any
    }).pipe(map(report => report.reportPdfUrl));
  }

  public getExportReports(data) {
    return this.httpClient.post<any>(AppConfig.settings.API + '/export/reports', data);
  }

  // Llama a API para exportar las puntuaciones
  public getExportScores(data) {
    return this.httpClient.post<any>(AppConfig.settings.API + '/export/scores?origin=ct', data);
  }

}
